import { useLocation } from 'react-router-dom';
import TventLogo from '../../pages/logo_no_bg.png';

export const useBranding = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  // Check if we should hide branding entirely
  if (currentPath === '/login') {
    return { hide: true };
  }

  // Check if we should show Tvent branding
  const tventRoutes = ['/tour-guide', '/qr-scanner', '/join-tour', '/tour-participant'];
  const isTventRoute = tventRoutes.some(route => currentPath.startsWith(route));

  if (isTventRoute) {
    return {
      hide: false,
      brand: {
        name: 'Tvent',
        logoSrc: 'build/icons/tvent-logo.svg'
      }
    };
  }

  // Default to Tvent branding for all other routes
  return {
    hide: false,
    brand: {
      name: 'Tvent',
      logoSrc: TventLogo
    }
  };
};